const data = {
  citiesRequiringStates: [
    "BLUE",
    "NEW ENGLAND",
    "MIDWEST",
    "NORTH",
    "SOUTH",
    "EAST",
    "WEST",
    "CONTACT",
    "NOON",
    "DATE",
    "COYOTE",
    "JONES"
  ]
};

export default data;